<div class="table-responsive">
  <table class="table table-bordered mb-0">
    <tbody>
      <tr *ngFor="let key of (viewLogsData | keyvalue)">
        <!-- FIELD NAME -->
        <td class="key-column">
          {{ key.key | transformKey }}
        </td>

        <!-- VALUE COLUMN -->
        <td style="padding: 2px !important;">

          <!-- OBJECTS -->
          <ng-container *ngIf="isObject(key.value) && !isArray(key.value); else simpleValue">
            <table class="table table-bordered mb-0 table-sm">
              <tbody>
                <!-- Show Diff button if old/new values are objects -->
                <td *ngIf="isObject(key.value['old_value']) || isObject(key.value['new_value'])" colspan="3"
                  style="width: auto !important;">
                  <button class="btn"
                    (click)="openComparisonPopup('' + key.key, key.value['old_value'], key.value['new_value'], comparisonTemplate)">
                    Show Diff <i class="fa fa-eye"></i>
                  </button>
                </td>

                <!-- Old Value -->
                <td *ngIf="!isObject(key.value['old_value']) && !isObject(key.value['new_value'])" class="old-value-td"
                  [ngStyle]="
    key.key === 'password'
      ? {
          width: 'auto',
          maxWidth: '500px',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          display: 'inline-block',
          backgroundColor: '#DEFFEF'
        }
      : {
          width: 'auto',
          backgroundColor: '#DEFFEF'
        }
  ">
                  {{ key.value['old_value'] | timezone }}
                </td>

                <!-- Arrow -->
                <td *ngIf="!isObject(key.value['old_value']) && !isObject(key.value['new_value'])"
                  style="width: 30px !important;">
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </td>

                <!-- New Value -->
                <td *ngIf="!isObject(key.value['old_value']) || !isObject(key.value['new_value'])" class="new-value-td" [ngStyle]="
    key.key === 'password'
      ? {
          width: 'auto',
          maxWidth: '500px',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          display: 'inline-block',
          backgroundColor: '#DEFFEF'
        }
      : {
          width: 'auto',
          backgroundColor: '#DEFFEF'
        }
  ">
                  {{ key.value['new_value'] ?? '' | timezone }}
                </td>
              </tbody>
            </table>
          </ng-container>

          <!-- SIMPLE STRINGS / NUMBERS / FALLBACK -->
          <ng-template #simpleValue>
        <td>
          {{ key.value }}
        </td>
        </ng-template>

        </td>

        <!-- Comparison Popup Modal -->
        <ng-template #comparisonTemplate let-modal>
          <div class="modal-header">
            <h5 class="modal-title">
              Comparison: {{ comparisonField | transformKey }}
            </h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(); closePopup()">
            </button>
          </div>

          <div class="modal-body">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Old Value</th>
                  <th>New Value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let field of getComparisonFields(comparisonOld, comparisonNew)">
                  <td>{{ field | transformKey }}</td>

                  <!-- Old Value -->
                  <td class="old-value-td">
                    <ng-container *ngTemplateOutlet="renderValue; 
                        context: { value: getComparisonValue(comparisonOld, field) }">
                    </ng-container>
                  </td>

                  <!-- New Value -->
                  <td class="new-value-td">
                    <ng-container *ngTemplateOutlet="renderValue; 
                        context: { value: getComparisonValue(comparisonNew, field) }">
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.close(); closePopup()">
              Close
            </button>
          </div>
        </ng-template>

        <!-- Render Value Template -->
        <ng-template #renderValue let-value="value">
          <!-- Arrays -->
          <ng-container *ngIf="isArray(value); else notArray">
            <ng-container *ngIf="value.length > 0 && isObject(value[0]); else flatArray">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th *ngFor="let key of getObjectKeys(value[0])">{{ key }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of value">
                    <td *ngFor="let key of getObjectKeys(item)">
                      {{ item[key] | timezone }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <!-- Flat Array -->
            <ng-template #flatArray>
              <ul class="mb-0 ps-3">
                <li *ngFor="let item of value">
                  {{ isObject(item) ? (item | json) : (item | timezone) }}
                </li>
              </ul>
            </ng-template>
          </ng-container>

          <!-- Objects -->
          <ng-template #notArray>
            <ng-container *ngIf="isObjectOfObjects(value); else simpleObject">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Key</th>
                    <th *ngFor="let subKey of getNestedObjectKeys(value)">{{ subKey }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let kv of value | keyvalue">
                    <td>{{ kv.key }}</td>
                    <td *ngFor="let subKey of getNestedObjectKeys(value)">
                      {{ asAny(kv.value)[subKey] | timezone }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <!-- Simple Object -->
            <ng-template #simpleObject>
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr *ngFor="let kv of value | keyvalue">
                    <td>{{ kv.key }}</td>
                    <td>{{ asAny(kv.value) | timezone }}</td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </ng-template>

          <!-- Plain String / Number -->
          <ng-container *ngIf="!isArray(value) && !isObject(value)">
            {{ value !== null && value !== undefined ? value : '' }}
          </ng-container>
        </ng-template>

      </tr>
    </tbody>
  </table>
</div>